import React from 'react';
import { push } from 'react-router-redux';
import * as routes from "../../constants/routes";
import * as authHandler from "../../utils/authHandler";
import * as actions from "../../actions/login";
import * as utils from "../../utils/utils";

export default class AuthRequiredComponent extends React.Component {
    constructor(props) {
        super(props);

        push(routes.LOGIN);
        if (!authHandler.isLoggedIn()) {
            push(routes.LOGIN);
        } else {
            let user = authHandler.getUser();
            if (utils.notNullNorUndefined(user)) {
                (actions.loggedIn(user));
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/AuthRequiredComponent.js